<div *ngIf="!timesheetTable">
    <p-table #dt [columns]="selectedColumns" [value]="rowData" [rows]="rows" [totalRecords]="totalRecords"
        [(selection)]="selectedRows" [loading]="isLoading" [paginator]="isPaginator"
        [globalFilterFields]="columns | fields" [resizableColumns]="true" [lazy]="true" (onLazyLoad)="lazyLoad($event)"
        stateStorage="local" [stateKey]="stateKey" [scrollable]="true" selectionMode="single" dataKey="id"
        (onRowSelect)="viewRow($event,'Tab')" *transloco="let t" [sortOrder]="-1">
        <ng-template pTemplate="caption" *ngIf="isToggle">
            <div class="flex align-items-center flex-wrap gap-2">
                <p-multiSelect appendTo="body" [options]="updatedColumns" [(ngModel)]="selectedColumns"
                    optionLabel="header" selectedItemsLabel="{{getSelectColumnsLabel() +' '+t('columns selected')}}"
                    [style]="{minWidth: '200px'}" [placeholder]="t('Choose Columns')" appendTo="body">
                </p-multiSelect>
                <span class="p-input-icon-left" *ngIf="!hideToggleSearch">
                    <i class="pi pi-search"></i>
                    <input *transloco="let t" pInputText type="text" class="min-w-[200px]"
                        [(ngModel)]="globalSearchString" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{t('Search with exact words')}}" />
                </span>
                <span
                    class="ml-auto flex items-center justify-center pt-1 right-0 w-6 h-6 shadow-lg rounded z-50 cursor-pointer bg-accent bg-opacity-90"
                    style="float: right;">
                    <button mat-mini-fab (click)="clear(dt)">
                        <i class="pi pi-filter-slash text-white font-sm"></i>
                    </button>
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns *transloco="let t" appendTo="body">
            <tr>
                <th style="width: 3rem" *ngIf="isSelectable">
                    <p-tableHeaderCheckbox (click)="postSelection()"></p-tableHeaderCheckbox>
                </th>
                <th *ngFor="let col of columns" pSortableColumn="{{col.field}}" pResizableColumn
                    style="min-width: 170px;justify-content: center;">
                    <span>{{t(col.header)}}</span>
                    <p-sortIcon *ngIf="(col.field !== 'actions') && isFilterable" field="col.field"></p-sortIcon>
                    <p-columnFilter *ngIf="col.type === 'text' && isFilterable" type="text" field="{{col.field}}"
                        display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                        [placeholder]="t('Search')" appendTo="body"></p-columnFilter>
                    <p-columnFilter *ngIf="col.type === 'array' && isFilterable" type="text" field="{{col.field}}"
                        display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                        [placeholder]="t('Search')" appendTo="body"></p-columnFilter>
                    <p-columnFilter *ngIf="col.type === 'number' && isFilterable" type="text" field="{{col.field}}"
                        display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                        [placeholder]="t('Search')" appendTo="body"></p-columnFilter>

                    <p-columnFilter *ngIf="col.type === 'date' && isFilterable" type="date" field="{{col.field}}"
                        display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                        placeholder="Select.." appendTo="body">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-calendar #calendar [ngModel]="value" (onSelect)="filter(calendar.value)"
                                (onInput)="setup(calendar.value, col.field)" dateFormat="dd.mm.yy"></p-calendar>
                        </ng-template>
                    </p-columnFilter>
                    <p-columnFilter *ngIf="col.type === 'multi-select' && isFilterable" field="{{col.field}}"
                        matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                        [showAddButton]="false" placeholder="Select.." appendTo="body">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [ngModel]="value" [options]="getAsSelect(col)" placeholder="Any"
                                (onChange)="filter($event.value)">
                                <ng-template let-option pTemplate="item">
                                    <div>
                                        <span class="p-ml-1">{{option.value | titlecase}}</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                    <p-columnFilter *ngIf="col.field === 'email' && isFilterable" type="text" field="{{col.field}}"
                        display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                        [placeholder]="t('Search')" appendTo="body"></p-columnFilter>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" *transloco="let t" let-rowData let-columns="columns" let-i="rowIndex">
            <tr class="cursor-pointer">
                <td *ngIf="isSelectable">
                    <div style="max-width: 5rem">
                        <p-tableCheckbox [value]="rowData" (click)="postSelection()"></p-tableCheckbox>
                    </div>
                </td>
                <td [style.min-width.px]="170" pResizableColumn *ngFor="let col of columns" class="cursor-pointer">
                    <ng-container *ngIf="col.type !== 'actions'">
                        <a *ngIf="url" [href]="'/' + url + '/' + (rowData?.id || rowData?._id)"
                            class="block w-full h-full flex items-center justify-center py-4 relative box-border">
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'verifiedStatus'">
                                <span *ngIf="rowData.status === 'verified' || !rowData.status">
                                    <mat-icon class="icon-size-5 mr-2 text-green-400"
                                        [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                                </span>
                                <span *ngIf="rowData.status === 'not verified'">
                                    <mat-icon class="icon-size-5 mr-2 text-red-400"
                                        [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                                </span>
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'id'"
                                (click)="onAction($event, 'View', rowData, i)">{{ i + 1 }}</div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'number'"
                                (click)="onAction($event, 'View', rowData, i)">{{
                                rowData[col.field]?rowData[col.field]:0 }}</div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'date'"
                                (click)="onAction($event, 'View', rowData, i)">
                                {{ rowData[col.field] | date: getCountryDateFormat(rowData) }}
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'timestamp'"
                                (click)="onAction($event, 'View', rowData, i)">{{
                                rowData[col.field] | date: 'dd.MM.yyyy HH:mm:ss' }}</div>
                            <div [style.text-align]="col.fieldAlign || 'center'" class="cursor-pointer truncate"
                                *ngIf="col.type === 'truncate-text'" (click)="onAction($event, 'View', rowData, i)">
                                {{ getRowData(rowData, col) }}
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'"
                                (click)="onAction($event, 'View', rowData, i)"
                                *ngIf="col.type === 'text' || col.type === 'taskAssignee'">
                                {{getRowData(rowData, col)}}
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'"
                                (click)="onAction($event, 'View', rowData, i)" *ngIf="col.type === 'array'">
                                <span
                                    class="text-md font-normal rounded px-1 py-1 leading-none text-primary-700 bg-primary-100 border-primary-300">
                                    {{ getRowData(rowData, col) }}
                                </span>
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'phone'"
                                (click)="onAction($event, 'View', rowData, i)">
                                <a [href]="'tel:' + getRowData(rowData, col)">{{ getRowData(rowData, col) }}</a>
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'email'"
                                (click)="onAction($event, 'View', rowData, i)">
                                <a [href]="'mailTo:' + getRowData(rowData, col)">{{ getRowData(rowData, col) }}</a>
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'multi-select'"
                                (click)="onAction($event, 'View', rowData, i)">
                                <div *ngIf="col?.colors" class="flex items-center justify-center">
                                    <div class="text-md font-normal rounded px-1 py-1 leading-none"
                                        [class]="'text-' + getColor(rowData, col) + '-700 bg-'+getColor(rowData, col)+'-100 border-'+getColor(rowData, col)+'-300'">
                                        {{getRowData(rowData, col)| titlecase}}
                                    </div>
                                </div>
                                <div *ngIf="!col?.colors" class="flex items-center justify-center">
                                    {{getRowData(rowData, col) | titlecase}}
                                </div>
                            </div>
                        </a>
                        <div *ngIf="!url"
                            class="block w-full h-full flex items-center justify-center py-4 relative box-border">
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'verifiedStatus'">
                                <span *ngIf="rowData.status === 'verified' || !rowData.status">
                                    <mat-icon class="icon-size-5 mr-2 text-green-400"
                                        [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                                </span>
                                <span *ngIf="rowData.status === 'not verified'">
                                    <mat-icon class="icon-size-5 mr-2 text-red-400"
                                        [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                                </span>
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'id'"
                                (click)="onAction($event, 'View', rowData, i)">{{ i + 1 }}</div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'number'"
                                (click)="onAction($event, 'View', rowData, i)">{{
                                rowData[col.field]?rowData[col.field]:0 }}</div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'date'"
                                (click)="onAction($event, 'View', rowData, i)">{{ rowData[col.field]
                                | date: 'dd.MM.yyyy' }}</div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'timestamp'"
                                (click)="onAction($event, 'View', rowData, i)">{{
                                rowData[col.field] | date: 'dd.MM.yyyy HH:mm:ss' }}</div>
                            <div [style.text-align]="col.fieldAlign || 'center'" class="cursor-pointer truncate"
                                *ngIf="col.type === 'truncate-text'" (click)="onAction($event, 'View', rowData, i)">
                                {{ getRowData(rowData, col) }}
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'"
                                (click)="onAction($event, 'View', rowData, i)"
                                *ngIf="col.type === 'text' || col.type === 'taskAssignee'">
                                {{getRowData(rowData, col)}}
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'"
                                (click)="onAction($event, 'View', rowData, i)" *ngIf="col.type === 'array'">
                                <span
                                    class="text-md font-normal rounded px-1 py-1 leading-none text-primary-700 bg-primary-100 border-primary-300">
                                    {{ getRowData(rowData, col) }}
                                </span>
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'phone'"
                                (click)="onAction($event, 'View', rowData, i)">
                                <a [href]="'tel:' + getRowData(rowData, col)">{{ getRowData(rowData, col) }}</a>
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'email'"
                                (click)="onAction($event, 'View', rowData, i)">
                                <a [href]="'mailTo:' + getRowData(rowData, col)">{{ getRowData(rowData, col) }}</a>
                            </div>
                            <div [style.text-align]="col.fieldAlign || 'center'" *ngIf="col.type === 'multi-select'"
                                (click)="onAction($event, 'View', rowData, i)">
                                <div *ngIf="col?.colors" class="flex items-center justify-center">
                                    <div class="text-md font-normal rounded px-1 py-1 leading-none" [class]="
                                            'text-' +
                                            getColor(rowData, col) +
                                            '-700 bg-' +
                                            getColor(rowData, col) +
                                            '-100 border-' +
                                            getColor(rowData, col) +
                                            '-300'
                                        ">
                                        {{ getRowData(rowData, col) | titlecase}}
                                    </div>
                                </div>
                                <div *ngIf="!col?.colors" class="flex items-center justify-center">
                                    {{ getRowData(rowData, col)| titlecase }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="col.type === 'actions'" [style.text-align]="col.fieldAlign || 'center'">
                        <button mat-mini-fab [matMenuTriggerFor]="menu">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <div *ngFor="let item of actionButtons">
                                <button *ngIf="rowData[item.field]== item.Onshow" mat-menu-item
                                    (click)="onAction($event, item.label, rowData, i)">
                                    <mat-icon class="icon-size-5 mr-2">{{item.icon}}</mat-icon>
                                    {{t(item.label)}}
                                </button>
                            </div>
                        </mat-menu>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length" class="text-md">{{t('No data found.')}}</td>
            </tr>
        </ng-template>
    </p-table>



</div>


<!-- todo remove Redundancy of some filed Timesheet table -->
<div *ngIf="timesheetTable">
    <p-table #dt [columns]="selectedColumns" [value]="rowData" [rows]="rows" [totalRecords]="totalRecords"
        [(selection)]="selectedRows" [loading]="isLoading" [paginator]="isPaginator"
        [globalFilterFields]="columns | fields" [resizableColumns]="true" [lazy]="true" (onLazyLoad)="lazyLoad($event)"
        stateStorage="local" [stateKey]="stateKey" *transloco="let t" styleClass="timesheet-table">
        <ng-template pTemplate="caption" *ngIf="isToggle">
            <p-multiSelect [options]="columns" [(ngModel)]="selectedColumns" optionLabel="header"
                selectedItemsLabel="{0} columns selected" [style]="{ minWidth: '200px' }"
                [placeholder]="t('Choose Columns')">
            </p-multiSelect>
            <span class="p-input-icon-left ml-2" *ngIf="!hideToggleSearch">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="globalSearchString"
                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                    placeholder="{{t('Search with exact words')}}" />
            </span>
        </ng-template>
        <ng-template pTemplate="header" let-columns *transloco="let t">
            <tr>
                <th style="width: 3rem" *ngIf="isSelectable">
                    <p-tableHeaderCheckbox (click)="postSelection()"></p-tableHeaderCheckbox>
                </th>
                <th *ngFor="let col of columns" pSortableColumn="{{ col.field }}" pResizableColumn>
                    <span *ngIf="col.field !== 'actions'">{{
                        col.header
                        }}</span>
                    <span *ngIf="col.field === 'actions'" class="flex items-center justify-center">
                        <span *ngIf="isFilterable"
                            class="flex items-center justify-center pt-1 right-0 w-6 h-6 shadow-lg rounded z-50 cursor-pointer bg-accent bg-opacity-90">
                            <button mat-mini-fab (click)="clear(dt)">
                                <i class="pi pi-filter-slash text-white font-sm"></i>
                            </button>
                        </span>
                    </span>
                    <p-sortIcon *ngIf="col.type !== 'actions' && isFilterable" field="col.field"></p-sortIcon>
                    <p-columnFilter *ngIf="col.type === 'text' && isFilterable" type="text" field="{{ col.field }}"
                        display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                        [placeholder]="t('Search')"></p-columnFilter>
                    <p-columnFilter *ngIf="col.type === 'array' && isFilterable" type="text" field="{{ col.field }}"
                        display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                        [placeholder]="t('Search')"></p-columnFilter>
                    <p-columnFilter *ngIf="col.type === 'date' && isFilterable" type="date" field="{{ col.field }}"
                        display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                        [placeholder]="t('Search')">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-calendar #calendar [ngModel]="value" (onSelect)="filter(calendar.value)"
                                (onInput)="setup(calendar.value, col.field)" dateFormat="dd.mm.yy"></p-calendar>
                        </ng-template>
                    </p-columnFilter>
                    <p-columnFilter *ngIf="col.type === 'multi-select' && isFilterable" field="{{ col.field }}"
                        matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                        [showAddButton]="false" placeholder="Select..">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [ngModel]="value" [options]="getAsSelect(col)" placeholder="Any"
                                (onChange)="filter($event.value)">
                                <ng-template let-option pTemplate="item">
                                    <div>
                                        <span class="p-ml-1">{{ option.value| titlecase }}</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
            <tr class="timesheet-row">
                <td *ngIf="isSelectable" class="p-4">
                    <div style="max-width: 5rem">
                        <p-tableCheckbox [value]="rowData" (click)="postSelection()"></p-tableCheckbox>
                    </div>
                </td>
                <td pResizableColumn pEditableColumn *ngFor="let col of columns" class="p-4">
                    <div *ngIf="col.type === 'id'" class="py-2">{{ i + 1 }}</div>
                    <div *ngIf="col.type === 'date'" class="py-2">
                        {{ rowData[col.field] | date: getCountryDateFormat(rowData) }}
                    </div>
                    <div *ngIf="col.type === 'text'" class="py-2">
                        {{ getRowData(rowData, col) }}
                    </div>
                    <div *ngIf="col.type === 'array'" class="py-2">
                        {{ getRowData(rowData, col) }}
                    </div>
                    <div *ngIf="col.type === 'time'" class="py-2">
                        {{ getRowData(rowData, col)| date : "HH:mm" }}
                    </div>

                    <div *ngIf="col.type === 'edit-time-starting'" class="py-2">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="ngx-timepicker-field-example p-2" (click)="setvalue(rowData[col.field])">
                                    <p-calendar (click)="setvalue(rowData[col.field])" [(ngModel)]="rowData[col.field]"
                                        [timeOnly]="true" [hourFormat]="24" inputId="timeonly" appendTo="body"
                                        (ngModelChange)="
                                            calculateTotalWorkingHour()
                                        " [defaultDate]="defaultDate"></p-calendar>


                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ getRowData(rowData, col) | date : "HH:mm" }}
                            </ng-template>
                        </p-cellEditor>
                    </div>
                    <div *ngIf="col.type === 'edit-time-ending'" class="py-2">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="ngx-timepicker-field-example p-2" (click)="setvalue(rowData[col.field])">
                                    <p-calendar (click)="setvalue(rowData[col.field])" [(ngModel)]="rowData[col.field]"
                                        [timeOnly]="true" [hourFormat]="24" inputId="timeonly" appendTo="body"
                                        (ngModelChange)="
                                            calculateTotalWorkingHour()
                                        " [defaultDate]="defaultDateEnding"></p-calendar>


                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ getRowData(rowData, col) | date : "HH:mm" }}
                            </ng-template>
                        </p-cellEditor>
                    </div>

                    <div *ngIf="col.type === 'edit-dropdown-input'" class="py-2">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-dropdown [options]="DropTownValue" appendTo="body" [(ngModel)]="rowData[col.field]"
                                    [style]="{ width: '100%' }" (ngModelChange)="
                                            calculateTotalWorkingHour()"></p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ getRowData(rowData, col) }}
                            </ng-template>
                        </p-cellEditor>
                    </div>

                    <div *ngIf="col.type === 'edit-number-input'" class="py-2">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="ngx-timepicker-field-example">
                                    <input type="number" pInputText [(ngModel)]="rowData[col.field]" (ngModelChange)="
                                            calculateTotalWorkingHour()
                                         ; checkValue(rowData,col)
                                        " pKeyFilter="int" placeholder="Break in Minutes" />
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ getRowData(rowData, col) }}
                            </ng-template>
                        </p-cellEditor>
                    </div>


                    <div *ngIf="col.type === 'edit-text'" class="py-2">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="ngx-timepicker-field-example">
                                    <input type="text" pInputText [(ngModel)]="rowData[col.field]" />
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ getRowData(rowData, col) }}
                            </ng-template>
                        </p-cellEditor>
                    </div>

                    <div *ngIf="col.type === 'phone'" class="py-2">
                        <a [href]="'tel:' + getRowData(rowData, col)">{{
                            getRowData(rowData, col)
                            }}</a>
                    </div>
                    <div *ngIf="col.type === 'email'" class="py-2">
                        <a [href]="'mailTo:' + getRowData(rowData, col)">{{
                            getRowData(rowData, col)
                            }}</a>
                    </div>
                    <div *ngIf="col.type === 'multi-select'" class="py-2">
                        <div *ngIf="col?.colors" class="flex items-center justify-center">
                            <div class="text-md font-normal rounded px-1 py-1 leading-none" [class]="
                                    'text-' +
                                    getColor(rowData, col) +
                                    '-700 bg-' +
                                    getColor(rowData, col) +
                                    '-100 border-' +
                                    getColor(rowData, col) +
                                    '-300'
                                ">
                                {{ getRowData(rowData, col) | titlecase}}
                            </div>
                        </div>
                        <div *ngIf="!col?.colors" class="flex items-center justify-center">
                            {{ getRowData(rowData, col)| titlecase }}
                        </div>
                    </div>

                    <div *ngIf="col.type === 'actions'" class="py-2">
                        <button mat-mini-fab [matMenuTriggerFor]="menu">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <div *ngFor="let item of actionButtons">
                                <button mat-menu-item (click)="
                                        onAction($event, item.label, rowData, i)
                                    ">
                                    <mat-icon>{{ item.icon }}</mat-icon>
                                    {{ item.label }}
                                </button>
                            </div>
                        </mat-menu>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length" class="text-md">
                    {{t('No data found')}}.
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>